import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONVENIOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    cancelarEvento(id) {
        return axiosJwt
            .get(`${api}/convenios/cancelarevento/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirEvento(evento) {
        return axiosJwt
            .post(`${api}/convenios/inserirevento`, evento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterarEvento(evento) {
        return axiosJwt
            .post(`${api}/convenios/alterarevento`, evento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentosMetaConsultoria(idMetaConsultoria) {
        return axiosJwt
            .get(
                `${api}/convenios/obterdocumentosmetaconsultoria/${idMetaConsultoria}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterMetasConsultoria(IdConsultoria) {
        return axiosJwt
            .get(`${api}/convenios/${IdConsultoria}/obtermetasconsultorias`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentoMetaConsultoria(documento) {
        const formData = new FormData()
        formData.append('idMetaConsultoria', documento.idMetaConsultoria)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)

        return axiosJwt
            .post(
                `${api}/convenios/inserirdocumentometaconsultoria`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDocumentoMetaConsultoria(idDocumentoMetaConsultoria) {
        return axiosJwt
            .get(
                `${api}/convenios/excluirdocumentometaconsultoria/${idDocumentoMetaConsultoria}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoMetaConsultoria(idMetaConsultoria, idDocumento) {
        return axiosJwt
            .get(
                `${api}/convenios/downloaddocumentometaconsultoria/${idMetaConsultoria}/${idDocumento}`,
                { responseType: 'blob' }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMetas(idEvento) {
        return axiosJwt
            .get(`${api}/convenios/${idEvento}/obtermetas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarMeta(idMeta) {
        return axiosJwt
            .get(`${api}/convenios/cancelarmeta/${idMeta}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirMeta(meta) {
        return axiosJwt
            .post(`${api}/convenios/inserirmeta`, meta)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposInstrumento() {
        return axiosJwt
            .get(`${api}/convenios/obtertiposinstrumento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
